import {SET_STATS, SetStatsAction} from './types';
import {DashboardStatsResponse} from '../../api/apiContracts';

export const setStatsAction = (stats: DashboardStatsResponse): SetStatsAction => {
    return {
        type: SET_STATS,
        stats: stats,
    };
};
